import config from 'config'
import { subscriptionModuleTypes } from '@/modules/base/util/constants'

const { agbUrl } = config

const getTexts = (type) => {
  let overrideWith = {}
  if (type === subscriptionModuleTypes.GMI) {
    overrideWith = {
      periodInfo: 'monatlich kündbar*',
      periodHint: '*zum Vertragmonatsende',
    }
  }

  return {
    agbUrl,
    periodInfo: '12 Monate',
    periodHint: '',
    ...overrideWith,
  }
}

export default getTexts
